import { useContext, useMemo } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import Search from 'home/components/Search/Search'
import GeoContext from 'contexts/geoContext'
import { getHomeOfferListParams } from 'home/helpers'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import OhNoRefreshError from 'components/Common/ErrorBoundary/OhNoRefreshError'
import { useAppSelector } from 'hooks/reduxHooks'
import Sheet from 'components/utils/Sheet'
import safeJsonStringify from 'lib/string/safeJsonStringify'

function UnhandledErrorPage() {
  const intl = useIntl()
  const { currentRegionCode, geoStateName } = useContext(GeoContext)

  const filters = useMemo(() => getHomeOfferListParams({
    region: currentRegionCode,
    subregion: geoStateName,
  }), [currentRegionCode, geoStateName])

  const state = useAppSelector(state => state)

  const errorMessage = intl.formatMessage({
    id: 'Cm0L2LbYFfxwabVtQdTN',
    defaultMessage: 'Our team are working on fixing it now. Please try refreshing the page.',
    description: 'Error message on unhandled error page explaining the team is fixing the issue',
  })

  return (
    <div>
      <Sheet background="neutral-six" desktopPadding="0 0 64">
        <OhNoRefreshError>
          {errorMessage}
        </OhNoRefreshError>
      </Sheet>
      <Search />
      <OfferCardCarouselSection
        title={<FormattedMessage
          id="dBHWEzkSx7Fz0GaLHnkL"
          defaultMessage="Explore our <i>top offers</i>"
          description="Title for top offers carousel section on unhandled error page"
          values={{
            i: (chunks: React.ReactNode) => <i>{chunks}</i>,
          }}
        />}
        filters={filters}
      />

      <div style={{ display: 'none' }} aria-hidden="true" id="unhandled-error-page-state">{state && safeJsonStringify(state, 2)}</div>
    </div>
  )
}

export default React.memo(UnhandledErrorPage)
